import { render } from "./ListLiens.vue?vue&type=template&id=16b64f87"
import script from "./ListLiens.vue?vue&type=script&lang=js"
export * from "./ListLiens.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__